export default ".filter-icons img {\n  cursor: pointer;\n}";